const boxSize = 30;

export default { boxSize };
